import { AbstractLocalDataAccessLayer } from "@/lib/utility/data/local-data-access-layer.abstract";
import { ILead, Lead } from "@/models/lead.entity";

export const LeadDataAccessLayer = new (class extends AbstractLocalDataAccessLayer<ILead, ""> {
  getIdentifier(entity: ILead): string {
    return (entity as ILead).id;
  }

  mapEntity(entity: ILead): ILead {
    return new Lead(entity);
  }
})();
